import { useEffect, useState } from 'react'
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds'
import { LoggerUtils, DateUtils } from '@ocean/utils'
import { useSelector } from 'hooks'
import { BigCalendarUtils } from 'components/common/BigCalendar/utils'
import { getNearestMaintenancePeriod } from 'modules/simulatorTrainings/common/slices/instructor'

const useCheckCurrentMaintenancePeriod = (duration?: number) => {
  const nearestMaintenancePeriod = useSelector(({ simulatorTrainingInstructor }) =>
    getNearestMaintenancePeriod(
      simulatorTrainingInstructor.listMaintenancePeriodsData.result?.list.maintenancePeriods
    )
  )

  const [isWithinMaintenancePeriod, setWithinMaintenancePeriod] = useState(false)
  const utcOffset = new Date().getTimezoneOffset()

  useEffect(() => {
    if (nearestMaintenancePeriod) {
      const { startDate, endDate } = nearestMaintenancePeriod
      const utcNow = DateUtils.addMinutes(new Date(), utcOffset)
      const additionLockTime = duration ? duration + BigCalendarUtils.DEFAULT_LAUNCH_DURATION : 0
      const start = DateUtils.subMinutes(new Date(startDate), additionLockTime)

      try {
        setWithinMaintenancePeriod(
          DateUtils.isWithinInterval(utcNow, { start, end: new Date(endDate) })
        )
      } catch (e) {
        LoggerUtils.error('useCheckCurrentMaintenancePeriod isWithinInterval error', e)
      }
    }
  }, [nearestMaintenancePeriod, duration, utcOffset])

  useEffect(() => {
    if (isWithinMaintenancePeriod && nearestMaintenancePeriod) {
      const { endDate } = nearestMaintenancePeriod
      const utcNow = DateUtils.addMinutes(new Date(), utcOffset)

      try {
        setTimeout(() => {
          setWithinMaintenancePeriod(false)
        }, differenceInMilliseconds(new Date(endDate), utcNow))
      } catch (e) {
        LoggerUtils.error('useCheckCurrentMaintenancePeriod differenceInMilliseconds error', e)
      }
    }
  }, [nearestMaintenancePeriod, isWithinMaintenancePeriod, utcOffset])

  return isWithinMaintenancePeriod
}

export default useCheckCurrentMaintenancePeriod
